<template>
  <li class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2 wf-items-center">
    <span
      class="wf-font-light wf-lowercase wf-text-gray-500 wf-w-1/2 wf-text-xs wf-tracking-wide"
    >Height</span>
    <input
      v-model="height"
      type="text"
      class="wf-w-1/2 focus:wf-bg-gray-300 wf-text-sm wf-bg-gray-300 wf-text-gray-700 wf-border wf-rounded focus:wf-outline-none wf-px-2 wf-py-1"
    />
  </li>
</template>

<script>
  import { HeightStyle } from '../styles/HeightStyles'
  import MenuStyleProperty from '../contracts/MenuStyleProperty'
  export default MenuStyleProperty.extend({
    computed: {
      height: {
        get() {
          let height = this.elementStyles(this.styles)[this.device].find(deviceStyle => deviceStyle.property === HeightStyle.property)
          if (! height) {
            height = {...HeightStyle, value: '30', touched: false}
            this.addToArray(this.module, [height], this.styles, this.device, {}, true, this.parentModule)
          }
          return height.value
        },
        set(value) {
          let height = {...HeightStyle, value: value, touched: false}
          this.addToArray(this.module, [height], this.styles, this.device, {}, true, this.parentModule)
        }
      },
    }
  })
</script>
